
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Crown, MapPin, Users, Snowflake } from "lucide-react";
import { VacationMascot } from "@/components/VacationMascot";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { LocalFavoritesContainer } from "@/components/local-favorites/LocalFavoritesContainer";

const ThemaPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  const handleShowAllVacations = () => {
    navigate('/alle-vakanties');
  };

  const handleShowDeals = () => {
    navigate('/deals');
  };

  const handleShowLuxury = () => {
    navigate('/luxe');
  };

  const handleShowRondreizen = () => {
    navigate('/rondreizen');
  };

  const handleShowThema = () => {
    navigate('/thema');
  };

  const handleShowFavoritesComparison = () => {
    navigate('/favorieten-vergelijken');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const themes = [
    {
      id: "luxe",
      title: "Luxe",
      description: "Ontdek de meest luxueuze zonvakanties",
      icon: Crown,
      route: "/luxe",
      color: "from-amber-600 to-orange-600"
    },
    {
      id: "rondreizen",
      title: "Rondreizen",
      description: "Ontdek prachtige rondreizen wereldwijd",
      icon: MapPin,
      route: "/rondreizen",
      color: "from-green-600 to-emerald-600"
    },
    {
      id: "wintersport",
      title: "Wintersport",
      description: "De beste ski- en snowboard bestemmingen",
      icon: Snowflake,
      route: "/wintersport",
      color: "from-blue-600 to-cyan-600"
    },
    {
      id: "jongerenreizen",
      title: "Jongerenreizen",
      description: "Feest, avontuur en nieuwe vrienden maken",
      icon: Users,
      route: "/jongerenreizen",
      color: "from-purple-600 to-pink-600"
    },
    {
      id: "reisaanbieder",
      title: "Reisaanbieders",
      description: "Zoek vakanties van jouw favoriete reisaanbieder",
      icon: Building2,
      route: "/thema/reisaanbieder",
      color: "from-blue-600 to-indigo-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 flex flex-col">
      <Header 
        onShowAllVacations={handleShowAllVacations}
        onShowDeals={handleShowDeals}
        onShowLuxury={handleShowLuxury}
        onShowRondreizen={handleShowRondreizen}
        onShowThema={handleShowThema}
        onShowFavoritesComparison={handleShowFavoritesComparison}
        onGoHome={handleGoHome}
        currentView="thema"
      />
      
      <main className="flex-1">
        <div className="container mx-auto px-4 py-8">
          <div className="space-y-6">
            <div className="space-y-4">
              <div className="flex items-center justify-center gap-4 sm:gap-6">
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-600 via-pink-500 to-red-500 bg-clip-text text-transparent">
                  Thema's
                </h1>
                <div className="flex-shrink-0">
                  <VacationMascot size="small" />
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-200">
              <p className="text-purple-800 text-center font-medium text-lg">
                🎯 Ontdek vakanties op jouw manier! Zoek per thema dat bij jou past
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {themes.map((theme) => {
                const IconComponent = theme.icon;
                return (
                  <Card 
                    key={theme.id}
                    className="group hover:shadow-lg transition-all duration-300 hover:scale-[1.02] cursor-pointer border-2 hover:border-purple-300"
                    onClick={() => navigate(theme.route)}
                  >
                    <CardHeader className="text-center">
                      <div className={`w-16 h-16 mx-auto rounded-full bg-gradient-to-r ${theme.color} flex items-center justify-center mb-4`}>
                        <IconComponent className="h-8 w-8 text-white" />
                      </div>
                      <CardTitle className="text-xl font-bold text-gray-800">
                        {theme.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="text-center">
                      <p className="text-gray-600 mb-4">
                        {theme.description}
                      </p>
                      <Button 
                        className={`w-full bg-gradient-to-r ${theme.color} hover:opacity-90 text-white`}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(theme.route);
                        }}
                      >
                        Verken {theme.title}
                      </Button>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </main>
      
      <LocalFavoritesContainer />
      <Footer />
    </div>
  );
};

export default ThemaPage;
